module.exports = __webpack_public_path__ + "icon-256-library-listing-raster.png";


//////////////////
// WEBPACK FOOTER
// ./src/styles/img/icon-256-library-listing-raster.png
// module id = 637
// module chunks = 11